var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11907 0.913687C5.83334 0.223483 5.08005 -0.143884 4.36016 0.0527875L1.09468 0.943373C0.449004 1.12149 0 1.70779 0 2.37573C0 11.5562 7.44381 19 16.6243 19C17.2922 19 17.8785 18.551 18.0566 17.9053L18.9472 14.6398C19.1439 13.92 18.7765 13.1667 18.0863 12.8809L14.524 11.3966C13.9191 11.1443 13.2178 11.3187 12.8059 11.8271L11.3067 13.6565C8.69434 12.4208 6.5792 10.3057 5.34351 7.69327L7.17293 6.19783C7.6813 5.78222 7.85571 5.0846 7.60338 4.47974L6.11907 0.917398V0.913687Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.5be096d7f9cba86e6058cb9297b1e6b7.svg";
export { ForwardRef as ReactComponent };